import { AttachmentStatusData } from 'chaika-frontend-types/frontend-cms/attachment';

import { LongList } from '@store/abstract/LongList';
import { AttachmentStatus } from 'chaika-enums';

interface AttachmentStatusListFilters {
    query?: string;
    status?: AttachmentStatus[];
}

class AttachmentStatusList extends LongList<AttachmentStatusData, AttachmentStatusData, AttachmentStatusListFilters> {
    protected create(params: AttachmentStatusData): AttachmentStatusData {
        return params;
    }

    protected filterValue(value: AttachmentStatusData, filterParams: AttachmentStatusListFilters): boolean {
        return (
            this.filterFieldValueIncludesString(value, filterParams.query, 'fileName') &&
            this.filterFieldValueByArray(value, filterParams.status, 'status')
        );
    }
}

export const attachmentStatusList = new AttachmentStatusList();
